export function AdminSparkline({ data = [], color = "#f59e0b", height = 60, testId }) {
  if (!data || data.length === 0) return <div style={{ height }} className="bg-slate-50 rounded" />;
  const values = data.map((d) => d.count);
  const maxV = Math.max(1, ...values);
  const w = 100;
  const h = height;
  const step = w / Math.max(1, data.length - 1);
  const points = values.map((v, i) => `${i * step},${h - (v / maxV) * (h - 8) - 4}`);
  const path = `M0,${h} L${points.join(" L")} L${w},${h} Z`;
  const linePath = `M${points.join(" L")}`;
  return (
    <svg data-testid={testId} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" className="w-full" style={{ height }}>
      <defs>
        <linearGradient id={`grad-${testId || "spark"}`} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={path} fill={`url(#grad-${testId || "spark"})`} />
      <path d={linePath} fill="none" stroke={color} strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
